import SHA256 from "crypto-js/sha256";
const PERSISTENT_LOGIN_DAYS = 7;
export const sha256Hash = (value: string) => {
  return SHA256(value.trim().toLowerCase()).toString();
};
export const setCookie = (
  msisdn: string,
  token: string,
  isTrivia?: boolean,
): void => {
  clearAllCookies();
  const now = Date.now();
  const data: CookieData = {
    msisdn,
    token,
    lastActivity: now, // Store current timestamp
    isTrivia,
  };

  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + PERSISTENT_LOGIN_DAYS); // 7 days

  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data),
  )}; SameSite=Strict; path=/; expires=${expirationDate.toUTCString()}`;

  console.log(
    `Cookie set for ${PERSISTENT_LOGIN_DAYS} days with activity tracking`,
  );
};

export const clearAllCookies = (): void => {
  document.cookie.split(";").forEach((cookie: string) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });

  // Also clear localStorage and sessionStorage
  localStorage.clear();
  sessionStorage.clear();
};
